// @flow

export const DASHBOARD_DATA_CHANGE: 'dashboard-application/data/change' =
  'dashboard-application/data/change';

export const DASHBOARD_ERROR: 'dashboard-application/error' =
  'dashboard-application/error';

export const DASHBOARD_LOADING: 'dashboard-application/loading' =
  'dashboard-application/loading';

export const DASHBOARD_UPDATE_QUERY_STRING: 'dashboard-application/query-string/update' =
  'dashboard-application/query-string/update';

export const DASHBOARD_UPDATE_STATUS: 'dashboard-application/query-string/reload' =
  'dashboard-application/query-string/reload';

export const DASHBOARD_UPDATE_APPLICATION: 'dashboard-application/update-application' =
  'dashboard-application/update-application';

export const DASHBOARD_UPDATE_ACTIVE_STEP: 'dashboard-application/active-step/update' =
  'dashboard-application/active-step/update';

export type Action =
  | {
      type: typeof DASHBOARD_DATA_CHANGE,
      applications: Array<any>,
      meta: {},
      isLoading: boolean
    }
  | {
      type: typeof DASHBOARD_ERROR,
      isLoading: boolean,
      error: any
    }
  | {
      type: typeof DASHBOARD_LOADING,
      isLoading: boolean
    }
  | {
      type: typeof DASHBOARD_UPDATE_QUERY_STRING,
      queryString: string
    }
  | {
      type: typeof DASHBOARD_UPDATE_STATUS,
      status: string
    }
  | {
      type: typeof DASHBOARD_UPDATE_APPLICATION,
      applicationId: any,
      value: any,
      key: string
    }
  | {
      type: typeof DASHBOARD_UPDATE_ACTIVE_STEP,
      activeStep: string
    };
